export type ConfiguracaoPeloLocalStorage<T> = { valor: T, expiracao: Date }

export class GerenciadorDoLocalStorage {
    public static chaves = {
        alunoSelecionado: "bdfc8206-6fa1-4c88-ae22-e496747fd6e7"
    }

    public static set<T>(chave: string, v: T, expiracao: Date | undefined = undefined): ConfiguracaoPeloLocalStorage<T> {
        if(expiracao == null){
            expiracao = new Date();
            expiracao.setDate(expiracao.getDate() + 1);
        }

        const opt: ConfiguracaoPeloLocalStorage<T> = {
            expiracao: expiracao,
            valor: v
        }

        localStorage.setItem(chave, JSON.stringify(opt))

        return opt;
    }

     public static get<T>(chave: string): ConfiguracaoPeloLocalStorage<T> | undefined {
        const r = localStorage.getItem(chave);
        if(r == undefined) return undefined;
        const p = JSON.parse(r)
        if(p as T != undefined) return p as ConfiguracaoPeloLocalStorage<T>;

        return undefined;
    }

     public static clear(): void {
        Object.values(this.chaves).forEach((c) => {
            localStorage.removeItem(c)
        })
    }

}
